import * as Msal from "msal";

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZUREAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AZUREAD_TENANT_ID}`,
    redirectUri:process.env.VUE_APP_AZUREAD_REDIRECT_URI
  },
};

export const loginRequest = {
  scopes: ["https://service.powerapps.com/user"], 
};

export const msalApp = new Msal.UserAgentApplication(msalConfig);